<template>
    <!-- Main Sonicu Sidebar div -->
    <div    class="w-full flex flex-col justify-center items-center">

        <!-- Link to operations pages -->
        <div    class="justify-around">
            <undecorated-link       v-if="permissions.can('view_operations_pages')"
                                    :class="linkClasses"
                                    :href="operationsLink">
                Operations
            </undecorated-link>
        </div>

        <!-- Link to production pages. -->
        <undecorated-link       v-if="company.getCompanyId() === 'sonicu' && permissions.can('view_production_pages')"
                                :class="linkClasses"
                                :href="productionLink">
            Production
        </undecorated-link>

        <!-- Link to engineering pages. -->
        <undecorated-link       v-if="company.getCompanyId() === 'sonicu' && showEngineering && permissions.can('view_engineering_pages')"
                                :class="linkClasses"
                                :href="engineeringLink">
            Engineering
        </undecorated-link>

        <!-- Network Maintenance Page -->
        <undecorated-link       v-if="networkMaintenanceEnabled && permissions.can('edit_network_maintenance_mode')"
                                :class="linkClasses"
                                :href="networkMaintenanceLink">
            Network Maintenance
        </undecorated-link>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "SonicuSidebar",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {UndecoratedLink},
    emits: [],
    props: {
        networkMaintenanceEnabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            'linkClasses': "group grid grid-cols-6 gap-x-2 plain-link items-center py-3 text-sm leading-5 font-medium rounded-md focus:outline-none "
                + 'ml-2 lg:ml-12 text-gray-600 hover:text-gray-900 hover:bg-gray-50 focus:text-gray-900 focus:bg-gray-100 focus:no-underline',
            showEngineering: false,
        }
    },
    created() { },
    mounted() {
        axios.get('/api-internal/is-sonicu-engineer'
        ).then(response => {
            let data = response.data
            this.showEngineering = data.isEngineer
        })
    },
    methods: {},
    computed: {
        operationsLink() {
            // return '/operations'
            return this.company.buildCompanyRoute('operations')
        },
        productionLink() {
            return '/production'
        },
        engineeringLink() {
            return '/engineering'
        },
        networkMaintenanceLink() {
            return `network-maintenance`
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>